<purple-select class="edit-item-field-select" [scrollFunction]="rolesScrollFunction"
  [searchIdFunction]="rolesSearchByIdFunction" (onValueChange)="onSelectRole($event)"
  [searchNameFunction]="rolesSearchFunction" [placeholder]="'select_role_tab_modal' | translation: 'Seleziona ruolo': []">
</purple-select>